import { GetOrgSettings } from '../gql/leadGenQueries.gql'
import apolloClient from '~/util/apolloClient'
const { provider } = apolloClient()

export default {
  fetchOrgSettings (context) {
    const orgGuid = context.state.orgGuid
    const orgType = context.state.orgType
    if (!orgGuid || !orgType) return

    return provider.clients.defaultClient.query({
      query: GetOrgSettings,
      variables: { orgGuid, orgType }
    }).then(({ data: { publicData: { organization } } }) => {
      context.commit('setSettings', {
        loanOfficerTitle: organization?.lead_gen_setting_loan_officer_title || null,
        landingPageTitle: organization?.lead_gen_setting_landing_page_title_text || null
      })
    }).catch(() => {
      context.commit('setSettings', { loanOfficerTitle: null, landingPageTitle: null })
    })
  }
}
